@for (item of totalsForDisplay; track $index; let isLast = $last) {
@if (!!item.value || isLast) {
<p class="flex flex-justify-between flex-middle"
   [ngClass]="isLast ? 's2 m-t-2' : 'p2'">
    <span>{{item.label | translate}}:</span>
    @if (item.hideCurrency) {
    <span class="price">{{item.value}}</span>
    } @else {
    <price class="price"
           [value]="item.value"
           [precision]="2">
    </price>
    }
</p>
}
}
